import {Injectable} from '@angular/core';
import {User} from '@models/user.interface';
import {buildPath, imgByRole} from '@utils/util-builder';
import {firstValueFrom} from 'rxjs';
import {AccountRole} from '@enums/AccountRole';
import {ApiResponse} from '@models/api.response';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class AuthUtilsService {
    constructor(private readonly _http: HttpClient) {
    }

    async fetchUserFromServer(firebaseUser: any): Promise<User> {
        const getAccountUrl: string = buildPath(['data-core/Account/getAccount']);
        const account = await firstValueFrom(this._http.get<any>(getAccountUrl));

        const user: User = {
            id: account.id,
            name: `${account.name} ${account.lastName}`,
            email: firebaseUser.email || '',
            rol: account.rol,
            phone: account.phone,
            avatar: imgByRole(account.rol),
            statusBack: account.status,
            boundedHotels: [],
            canEdit: account.canEdit
        };

        if (account.rol === AccountRole.semiMaster) {
            try {
                const boundedHotelsUrl: string = buildPath(['data-core/GroupHotel/getBoundedHotels']);
                const response: ApiResponse<number[]> = await firstValueFrom(this._http.get<ApiResponse<number[]>>(boundedHotelsUrl));
                user.boundedHotels = response.data;
            } catch (error) {
                console.error('Error fetching bounded hotels:', error);
                user.boundedHotels = [];
            }
        }

        try {
            const sirocAccesoUrl: string = buildPath(['data-core/api/siroc/acceso']);
            const response: ApiResponse<boolean> = await firstValueFrom(this._http.get<ApiResponse<boolean>>(sirocAccesoUrl));
            user.sirocEnabled = response.data === true;
        } catch (error) {
            console.error('Error fetching SIROC access:', error);
            user.sirocEnabled = false;
        }

        return user;
    }
}
